





































































import SearchInput from './SearchInput.vue'
import { Component, Vue, Watch } from 'vue-property-decorator'
import router from '@/router'
import { State, Getter, Action, Mutation, namespace } from 'vuex-class'
import cartsApi from '@/api/cartsApi'
import publicApi from '@/api/publicApi'
@Component
export default class PageHeader extends Vue {
  private searchText: string = ''
  private currentUser: any = this.$store.state.user.current
  private inputStyle: boolean = false
  private dataList: any[] = []
  private searchStr: any = ''
  public mounted() {
    this.getCarts()
  }

  @Watch('$route')
  public watchRouter(router: any) {
    if (router.name !== 'goods-list') {
      this.searchText = ''
    }
  }

  // 购物车的数量
  get getCartList() {
    return this.$store.state.carts.cartsAmount
  }

  // 获取购物车数量
  protected getCarts() {
    if (localStorage.getItem('token')) {
      cartsApi.getCartsList({
      }).then((res) => {
        if (res.code === 200) {
          let cartsLenth = res.data.length
          this.$store.commit('changeCartsAmount', cartsLenth)
        }
      })
    }
  }

  // 搜索
  protected seach(): void {
    let params = JSON.stringify({ resourceName: this.searchText })
    router.push({ name: 'goods-list', query: { params } });
  }
  // 订单中心
  protected goOrder() {
    router.push({ name: 'order' })
  }
  // 点logo
  protected goIndex() {
    router.push({ name: 'index' })
  }
  // 购物车
  protected goCarts() {
    router.push({ name: 'carts' })
  }
  // 去登录
  protected goLogin() {
    window.location.href = '/user/#/login'
  }
  // 退出
  protected exit() {
    localStorage.removeItem('token')
    window.location.href = '/user/#/login'
  }

  // 个人中心
  protected goUserCenter() {
    window.location.href = '/user/#/'
  }
  // 商户中心
  protected goMerchants() {
    window.location.href = '/user/#/'
  }

  protected handleSearch(value: any) {
    this.queryResources(value)
  }

  protected handleChange(value: any) {
    this.$router.push({ name: 'goods-details', query: { id: value } })
  }

  protected queryResources(data: any) {
    publicApi.getSearchResources({
      name: data
    }).then((res) => {
      if (res.code === 200) {
        this.dataList = res.data
      }
    })
  }

  protected filterOption(input: any, option: any) {
    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
  }

}
